import styled, { keyframes, css } from "styled-components";

import { rowFadeOutAnim, textApearAnim, textClickAnim } from "../../animations";
const autoTextopac = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    animation-timing-function: cubic-bezier(0.17, 0.17, 0, 1);
    opacity: 1;
  }
`;
const autoTextotrans = keyframes`
  0% {
    transform: translateY(35px);
  }
  100% {
    animation-timing-function: cubic-bezier(0.17, 0.17, 0, 1);
    transform: translateY(0px);
  }
`;
const autoTextopacAnim = css`
  ${autoTextopac}
`;
const autoTextotransAnim = css`
  ${autoTextotrans}
`;
export const ResultRow = styled.div`
  white-space: nowrap;
  animation: ${(p) => (p.textApear ? textApearAnim : null)};
  animation-duration: 0.6s;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 16px;
    height: 16px;
    margin-left: 4px;
    path {
      ${(p) => (!p.win ? "fill:#233b50" : "fill: #ffb000;")};
    }
  }
`;
export const TextRow = styled.div`
  text-align: center;
  text-transform: uppercase;
  font-size: 19px;
  color: ${(props) => (props.win ? "#ffb000" : "#233b50")};
  position: relative;
  white-space: nowrap;
  pointer-events: ${(p) => (p.newDisable ? "none" : "auto")};
  p {
    cursor: pointer;
    color: #233b50;
    animation: ${(p) => (p.textApear ? textApearAnim : null)};
    animation-duration: 0.6s;
  }
  animation: ${(p) =>
    p.btnClick ? textClickAnim : p.fadeOut ? rowFadeOutAnim : null};
  animation-duration: ${(p) =>
    p.btnClick ? "0.5s" : p.fadeOut ? "0.217s" : "0.3s"};
  animation-fill-mode: forwards;
  margin: 5px 0px 40px;
  ${(p) =>
    p.fadeOut
      ? "position: absolute; width: 100%; max-width: 315px; top: -15px; z-index: 0; margin: 0 auto;"
      : null}

  @media only screen and (min-height: 637px) {
    font-size: 20px;
  }
`;
export const TextGrid = styled.div`
  display: grid;
  grid-template-columns: 47% 47%;
  grid-row-gap: 16px;
  grid-column-gap: 6%;
  text-transform: uppercase;
  /* font-size: 14px; */
  color: #233b50;
  /* margin: 39px 0px 39px; */
  white-space: nowrap;
  overflow: hidden;
  z-index: 1;
  position: relative;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  p {
    font-size: 12px;
    line-height: 1.2;
  }
  span {
    font-size: 16px;
    color: #ffb000;
    line-height: 1.2;
  }
  animation: ${(p) =>
    p.textApear ? textApearAnim : p.fadeOut ? rowFadeOutAnim : null};
  animation-duration: ${(p) => (p.fadeOut ? "0.217s" : "0.6s")};
  animation-fill-mode: forwards;
  font-size: 16px;
  margin: 39px 0px 45px;
  ${(p) =>
    p.fadeOut ? "position: absolute; top: 12px; width: 100%; margin: 0;" : null}
`;
export const AutoResult = styled.div`
  /* font-size: 16px; */
  line-height: 1.2;
  text-align: center;
  text-transform: uppercase;
  /* margin: 44px auto; */
  color: ${(props) => (props.win ? "#ffb000;" : "#233b50;")};
  font-size: 20px;
  margin: 56px auto;
  div {
    animation: ${(props) => (props.autoAnimate ? autoTextotransAnim : null)};
    animation-duration: 0.467s;
    animation-fill-mode: forwards;
    :last-child {
      animation-delay: 0.083s;
    }
  }
  p {
    animation: ${(props) => (props.autoAnimate ? autoTextopacAnim : null)};
    animation-duration: 0.467s;
    animation-fill-mode: forwards;
    opacity: 0;
    /* animation-iteration-count: infinite; */
  }
  span {
    animation: ${(props) => (props.autoAnimate ? autoTextopacAnim : null)};
    animation-duration: 0.48s;
    animation-fill-mode: forwards;
    opacity: 0;
    animation-delay: 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  svg {
    width: 16px;
    height: 16px;
    margin-left: 4px;
    path {
      ${(p) => (!p.win ? "fill:#233b50" : "fill: #ffb000;")};
    }
  }
  @keyframes textAnim {
    0% {
      transform: translateY(10px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  /* @media only screen and (min-width: 375px) {
    font-size: 20px;
    margin: 56px auto;
  } */
`;
